const getMovieExtensions = (cinemaId, movieExtension, movieExtensionsItems, cliMovieRelevantSourceMovies) => {
    Object.keys(cliMovieRelevantSourceMovies).map(cliMovieRelevantSourceMoviesPk => {
        const sourceMovie = cliMovieRelevantSourceMovies[cliMovieRelevantSourceMoviesPk]
        if(!sourceMovie) {
            return ''
        }

        if(cinemaId === sourceMovie.cinema) {
            const extensionItem = _.find(movieExtensionsItems, movieExtensionsItem => {
                const movieDataPk = _.values(movieExtensionsItem.movieDataPk)
                return _.contains(movieDataPk, sourceMovie.pk)
            })
            const extensionItemfilter = _.filter(movieExtensionsItems, movieExtensionsItem => {
                const movieDataPk = _.values(movieExtensionsItem.movieDataPk)
                
                return _.contains(movieDataPk, sourceMovie.pk)
            })

            if(movieExtension[cinemaId]) {
                
            }
        
            movieExtension[cinemaId] = extensionItem

        }
    })
}

export default getMovieExtensions